// extracted by mini-css-extract-plugin
export var attachment = "_qp-a";
export var emailContainer = "_qp-4";
export var emailContentPaddedContainer = "_qp-b";
export var emailHeader = "_qp-6";
export var emailIframe = "_qp-3";
export var emailInfoIcon = "_qp-9";
export var emailShortenedSummary = "_qp-e";
export var infoDropdown = "_qp-0";
export var infoRowBoundedContent = "_qp-d";
export var internal = "_qp-5";
export var merchant = "_qp-8";
export var messageInputContainer = "_qp-h";
export var normal = "_qp-7";
export var replyCard = "_qp-f";
export var subtleButton = "_qp-1";
export var subtleButtonIconContainer = "_qp-2";
export var toggleViewRepliesButton = "_qp-c";
export var wrappingText = "_qp-g";